var isCanceledError = function (error) {
    return (error === null || error === void 0 ? void 0 : error.name) !== undefined && error.name === 'CanceledError';
};
var isErrorCodeResult = function (error) {
    return (error === null || error === void 0 ? void 0 : error.errorCode) !== undefined;
};
var isValidationErrorResult = function (error) {
    return (error === null || error === void 0 ? void 0 : error.data) !== undefined;
};
var isNotNullOrEmptyString = function (error) {
    return error !== null && (error === null || error === void 0 ? void 0 : error.length) !== undefined && (error === null || error === void 0 ? void 0 : error.length) > 0;
};
var isAxiosResponse = function (error) {
    return (error === null || error === void 0 ? void 0 : error.status) !== undefined;
};
var isAxiosErrorResponse = function (error) {
    var _a;
    return ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) !== undefined;
};

var emptyCustomSelectItem = {
    value: '',
    label: ''
};

var accountsStoreName = 'accounts';
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Undefined"] = 1] = "Undefined";
    AccountType[AccountType["Phone"] = 2] = "Phone";
})(AccountType || (AccountType = {}));

export { AccountType as A, isErrorCodeResult as a, isValidationErrorResult as b, isNotNullOrEmptyString as c, isAxiosResponse as d, isAxiosErrorResponse as e, emptyCustomSelectItem as f, accountsStoreName as g, isCanceledError as i };
